import { Button, message } from 'antd';
import dayjs from 'dayjs';

import { useNotifyBillingAdmins } from '../../../api/generated/api';

import type { NotifyBillingAdminsBodyDtoAction } from '../../../api/generated/model/notifyBillingAdminsBodyDtoAction';
import type { ButtonProps } from 'antd';

type Props = {
  organizationId: string;
  /** What the rep was trying to do; the email names it ("tried to send a text"). */
  action?: NotifyBillingAdminsBodyDtoAction;
  size?: ButtonProps['size'];
  type?: ButtonProps['type'];
};

/**
 * The rep's way out of an out-of-credits block (UC-17): emails the billing managers and the owner.
 * No permission needed; the API sends at most one email per organization an hour and says when
 * the next one is allowed.
 */
export const NotifyAdminButton = ({ organizationId, action, size = 'small', type }: Props) => {
  const notifyMutation = useNotifyBillingAdmins();

  const handleClick = async () => {
    try {
      const { data } = await notifyMutation.mutateAsync({
        organizationId,
        data: action ? { action } : {},
      });
      if (data.sent) {
        message.success('Your billing admin was notified.');
      } else {
        message.info(`Already notified. You can notify again after ${dayjs(data.nextAllowedAt).format('h:mm A')}.`);
      }
    } catch {
      message.error('Failed to notify your billing admin. Please try again.');
    }
  };

  return (
    <Button
      size={size}
      type={type}
      loading={notifyMutation.isPending}
      onClick={handleClick}
      data-testid="notify-admin"
    >
      Notify admin
    </Button>
  );
};
